var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCardReceive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9297 18.6666H42.0697C39.1063 18.6666 37.333 16.8933 37.333 13.9299V7.06992C37.333 4.10659 39.1063 2.33325 42.0697 2.33325H48.9297C51.893 2.33325 53.6663 4.10659 53.6663 7.06992V13.9299C53.6663 16.8933 51.893 18.6666 48.9297 18.6666ZM49.443 10.9433C49.163 10.6633 48.7897 10.5233 48.4163 10.5233C48.043 10.5233 47.6697 10.6633 47.3897 10.9433L46.9697 11.3633V6.13659C46.9697 5.31992 46.3163 4.66659 45.4997 4.66659C44.683 4.66659 44.0297 5.31992 44.0297 6.13659V11.3633L43.6097 10.9433C43.0497 10.3833 42.1163 10.3833 41.5563 10.9433C40.9963 11.5033 40.9963 12.4366 41.5563 12.9966L44.473 15.9133C44.5897 16.0299 44.753 16.1233 44.9163 16.1933C44.963 16.2166 45.0097 16.2166 45.0563 16.2399C45.173 16.2866 45.2897 16.3099 45.4297 16.3099C45.4763 16.3099 45.523 16.3099 45.5697 16.3099C45.733 16.3099 45.873 16.2866 46.0363 16.2166C46.0597 16.2166 46.0597 16.2166 46.083 16.2166C46.2463 16.1466 46.3863 16.0533 46.503 15.9366C46.5263 15.9133 46.5263 15.9133 46.5497 15.9133L49.4663 12.9966C50.0263 12.4366 50.0263 11.5033 49.443 10.9433Z",
    fill: "#454F5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M51.3337 18.1298V20.9998H4.66699V17.5931C4.66699 12.2498 9.00699 7.93311 14.3503 7.93311H37.3337V13.9298C37.3337 16.8931 39.107 18.6664 42.0703 18.6664H48.9303C49.8637 18.6664 50.657 18.5031 51.3337 18.1298Z",
    fill: "#25BBBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 21V38.4067C4.66699 43.75 9.00699 48.0667 14.3503 48.0667H41.6503C46.9937 48.0667 51.3337 43.75 51.3337 38.4067V21H4.66699ZM18.667 40.25H14.0003C13.0437 40.25 12.2503 39.4567 12.2503 38.5C12.2503 37.5433 13.0437 36.75 14.0003 36.75H18.667C19.6237 36.75 20.417 37.5433 20.417 38.5C20.417 39.4567 19.6237 40.25 18.667 40.25ZM33.8337 40.25H24.5003C23.5437 40.25 22.7503 39.4567 22.7503 38.5C22.7503 37.5433 23.5437 36.75 24.5003 36.75H33.8337C34.7903 36.75 35.5837 37.5433 35.5837 38.5C35.5837 39.4567 34.7903 40.25 33.8337 40.25Z",
    fill: "#25BBBB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardReceive);
export default __webpack_public_path__ + "static/media/card-receive.7cb49b35b3a5eb94ca843ff801e42c3b.svg";
export { ForwardRef as ReactComponent };